import { createLazyComponent } from '@muse-web/router'

export const AsyncAudioClaimContainer = createLazyComponent(
    () => import(/* webpackChunkName: 'audio-claim' */ './AudioClaimContainer'),
    'AudioClaimContainer',
)
